import React from 'react';
import { compose } from 'ramda';

import styleFile from './AvailServiceFooter.js';
import { RichText, Button } from '@synergycms_core/components/generic/';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

const AvailServiceFooter = class AvailServiceFooter extends React.Component {
  static displayName = 'AvailServiceFooter';

  render() {
    const { classes } = this.props.theme.styles;
    const { disableNextStepButton } = this.props.config;
    
    return (
      <div className={classes.defaultStyle}>
        <div className={classes.content}>
          <div className={classes.firstColumn} />
          <div className={classes.secondColumn}>
            <Button
              id={'td-d2-continue-extras-01'} 
              onClick={this.props.config.onNextClick} 
              innerStyle={[
                'toggleSecondButton', 
                'summary', 
                classes.robotoBtn
              ]}
              disabled={disableNextStepButton}
              ariaLabel={'_%continuar para reservar%_'} 
              translate={true}>
              <RichText
                rightIcon={{ unicodeContent: this.props.config.langCode === 'AR' ? '005C' : 'e000', innerStyle: ['size12', 'marginLeft14'] }}
                text={'_%continuar para reservar%_'}
                translate={true}
                ucFirst={true}
                innerStyle={[classes.textSpan]}
              />
            </Button>
          </div>
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager(['onNextClick', 'langCode', 'disableNextStepButton']),
  withThemeJSS({ styleFile })
)(AvailServiceFooter);
